<template>
    <div class="row">
        <div @dragstart="dragStart" @drop="drop" class="col-3">
            <h3>Characters</h3>
            <draggable :list="characters" class="dragArea list-group">
                <CharacterItem v-for="character in characters" v-bind:key="character.id" v-bind:character="character" />
            </draggable>
        </div>
    </div>
</template>

<script lang="ts">
import draggable from 'vuedraggable';
import CharacterItem from './CharacterItem.vue';

export default {
    name: 'CharacterList',
    display: 'Characters',
    components: {
        CharacterItem: CharacterItem,
        draggable: draggable,
    },
    props: {
        characters: {
            type: Array,
            default: function() {
                return [];
            },
        },
    },
    methods: {
        dragStart: function(evt) {
            const id = evt.target.id;
            const character = this.$props.characters.find(c => c.id == id);
            this.$store.dispatch('dropper/startDrag', character);
        },
        drop: function() {
            this.$store.dispatch('dropper/reset');
        },
    },
};
</script>
